import React from 'react'

import Downloader from '../../components/Downloader'
import PremiumKeyWarning from '../../components/PremiumKeyWarning'
import PrivateRoute from '../../components/PrivateRoute'
import SEO from '../../components/SEO'

const DownloaderPage = () => {
  return (
    <>
      <SEO page="downloader" />
      <PremiumKeyWarning />
      <PrivateRoute component={Downloader} />
    </>
  )
}

export default DownloaderPage
